// src/common/components/cartModal/components/checkout-stage/components/orderDetailsSection/OrderDetailsSection.tsx
import React from "react";
import styles from "./OrderDetailsSection.module.scss";
import { useTheme } from "../../../../hooks/useTheme";
import { Input } from "../../../input/Input";


interface OrderDetailsSectionProps {
  phone: string;
  comment: string;
  getValidationResult: (fieldName: string) => any;
  inputHandler: (value: any, fieldName: string, type: string) => void;
  setDirty: (fieldName: string) => void;
  maxCommentLength: number;
}

export default function OrderDetailsSection({
  phone,
  comment,
  getValidationResult,
  inputHandler,
  setDirty,
  maxCommentLength,
}: OrderDetailsSectionProps) {
  const { theme } = useTheme();

  return (
    <div className={styles.container}>
      <h3 className={styles.title} style={{ color: theme.text }}>
        Контактные данные
      </h3>

      <div className={styles.fieldContainer}>
        <Input
          type="tel"
          value={phone}
          onChange={(value) => inputHandler(value, "phone", "string")}
          fieldName="phone"
          placeholder="+7 (999) 123-45-67"
          label="Телефон *"
          validationResult={getValidationResult("phone")}
          onBlur={() => setDirty("phone")}
        />
      </div>

      <div className={styles.fieldContainer}>
        <Input
          value={comment}
          onChange={(value) => inputHandler(value, "comment", "string")}
          fieldName="comment"
          placeholder=""
          label="Комментарий к заказу"
          multiline
          rows={3}
          validationResult={getValidationResult("comment")}
          onBlur={() => setDirty("comment")}
        />
        <div className={styles.counter}>
          {comment.length}/{maxCommentLength}
        </div>
      </div>
    </div>
  );
}
